import { render, staticRenderFns } from "./DialogEditMusic.vue?vue&type=template&id=bb042408&scoped=true&"
import script from "./DialogEditMusic.vue?vue&type=script&lang=js&"
export * from "./DialogEditMusic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb042408",
  null
  
)

export default component.exports